import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  OwnerDashboardOverviewResponse,
  OwnerDashboardOverviewService,
} from '../../services/owner-dashboard-overview.service';
import { TranslatePipe } from '../../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-owner-header',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './owner-header.html',
  styleUrl: './owner-header.scss',
})
export class OwnerHeader implements OnInit, OnDestroy {
  overview: OwnerDashboardOverviewResponse | null = null;
  isLoading = false;
  errorMessage = '';

  private subscriptions = new Subscription();

  constructor(
    private router: Router,
    private overviewService: OwnerDashboardOverviewService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.overviewService.overview$.subscribe((data) => {
        this.overview = data;
      }),
    );

    this.subscriptions.add(
      this.overviewService.isLoading$.subscribe((loading) => {
        this.isLoading = loading;
      }),
    );

    this.subscriptions.add(
      this.overviewService.error$.subscribe((error) => {
        this.errorMessage = error;
      }),
    );

    this.overviewService.loadOverview();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onAddProperty() {
    this.router.navigate(['/dashboard/property_owner/add-property']);
  }

  get totalListings(): number {
    if (!this.overview) {
      return 0;
    }

    return (this.overview.totalUnits ?? 0) + (this.overview.totalProperties ?? 0);
  }

  get monthlyRevenueAmount(): number {
    const list = this.overview?.monthlyRevenue ?? [];

    if (!list.length) {
      return 0;
    }

    return list[list.length - 1].total ?? 0;
  }

  formatNumber(value: number): string {
    return value.toLocaleString('en-US');
  }
}
